import React from 'react';
import $ from "jquery";
import { Button, Input } from 'semantic-ui-react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import Title from '../../title';
import Server from '../../../functions/server';

export default class ServiceType extends React.Component {

    state = {
        data: [], values: {}
    }

    textHandle = (key) => event => { 
      this.setState({
          values: {
          ...this.state.values,
          [key]: event.target.value
          },
      });
    }

    getService = () => {
        let context = this;
        $.ajax({
        type: 'POST', data: { 'id': context.props.item.id },
        url: Server()+'machine/ServiceType/GetService.php',
        success: function(data) {
            console.log(data);
            console.log('datatatat');
            try {
                data = JSON.parse(data);
                context.setState({ data, load: false, ViewService: true })
            } catch (error) {
                alert('Try Agian!!!');
                context.setState({ load: false })
            }
        },
        error: function(e) {
            alert('Try again!!')
        }
    });
  }

  AddSpares = () => {
    let context = this;
    let { values } = this.state;
    $.ajax({
      type: 'POST', data: values,
      url: Server()+'machine/ServiceType/AddService.php',
      success: function(data) {
          console.log(data);
          console.log('datatatat');
          if (data == 1) {
            context.getService();
            context.setState({ values: { 'mid': context.props.item.id }, AddServiceDialog: false })
          }
          else {
            alert('Error')
          }
      },
      error: function(e) {
          alert('Try again!!')
      }
  });
  }

  render() {
    let { data, values } = this.state;
    let i = 1;
    return (
      <div>
        <u onClick={this.getService}>Services</u>
        <Dialog fullWidth={true} maxWidth={'md'} open={this.state.ViewService}
            onClose={ () => { this.setState({ ViewService: false }) }}
            aria-labelledby="max-width-dialog-title" >
            <DialogTitle id="max-width-dialog-title">{'View Service Details'}</DialogTitle>
            <DialogContent>
              <table id="table" width="100%">
                <tr id="th">
                    <th>Sino</th>
                    <th>Name</th>
                    <th>Hrs</th>
                    <th>Days</th>
                </tr>
                {
                  data.map((c) => {
                    return (
                      <tr>
                        <td>{i++}</td>
                        <td>{c.name}</td>
                        <td>{c.hrs}</td>
                        <td>{c.day}</td>
                      </tr>
                    )
                  })
                }
              </table>
              <center>
                <Button onClick={ () => this.setState({ AddServiceDialog: true, values: {'mid': this.props.item.id} })}>Add Service</Button>
              </center>

              <Dialog fullWidth={true} maxWidth={'lg'} open={this.state.AddServiceDialog}
                onClose={ () => { this.setState({ AddServiceDialog: false }) }}
                aria-labelledby="max-width-dialog-title" >
                <DialogTitle id="max-width-dialog-title">{'View Service Details'}</DialogTitle>
                <DialogContent>
                    <div style={{display: 'flex', width: '100%'}}>
                      <div style={{width: '33%'}}>
                        <b>Name</b><br/>
                        <Input style={{width: '99%'}} placeholder='name' 
                        value={values.name} onChange={this.textHandle('name')} />
                      </div>
                      <div style={{width: '33%'}}>
                        <b>Hrs</b><br/>
                        <Input style={{width: '99%'}} placeholder='hrs' 
                        value={values.hrs} onChange={this.textHandle('hrs')} />
                      </div>
                      <div style={{width: '33%'}}>
                        <b>Days</b><br/>
                        <Input style={{width: '99%'}} placeholder='day' 
                        value={values.day} onChange={this.textHandle('day')} />
                      </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={ () => { this.setState({ AddServiceDialog: false }) }}>Close</Button>
                    <Button onClick={this.AddSpares}>Submit</Button>
                </DialogActions>
              </Dialog>
            </DialogContent>
            <DialogActions>
                <Button onClick={ () => { this.setState({ ViewService: false }) }}>Close</Button>
            </DialogActions>
        </Dialog>
      </div>
    );
  }

}